import { render, staticRenderFns } from "./togetherToken.vue?vue&type=template&id=237cbae9&scoped=true"
import script from "./togetherToken.vue?vue&type=script&lang=js"
export * from "./togetherToken.vue?vue&type=script&lang=js"
import style0 from "./togetherToken.vue?vue&type=style&index=0&id=237cbae9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237cbae9",
  null
  
)

export default component.exports